import React, { ComponentProps, ReactElement } from "react";

import ServiceProvider from "e.sic-platform.webclient/src/services/service-provider/ServiceProvider";
import { ServiceContainer } from "e.sic-platform.webclient/src/services/service-provider/ServiceRegistry";

import sessionStorage from "e.sic-platform.webclient/src/services/storage/SessionStorageService";
import translationService from "e.sic-platform.webclient/src/services/translation/TranslationService";
import useThemeService from "e.sic-platform.webclient/src/services/theme-service/ThemeService";
import usePageTitle from "e.sic-platform.webclient/src/services/page-title/PageTitleKey";
import useConfiguration from "e.sic-platform.webclient/src/services/configuration/ConfigurationService";
import useErrorHandler from "e.sic-platform.webclient/src/services/error-handler/ErrorHandlerService";
import notificationsService from "e.sic-platform.webclient/src/services/notifications/NotificationsService";
import useMsalProvider from "../../AppMsalProvider";

export function withServices(
  WrappedComponent: React.ComponentType<any>,
  services: ServiceContainer<any, any>[]
) {
  return (props: any) => {
    return (
      <ServiceProvider services={services.map((x) => x.Provider)}>
        <WrappedComponent {...props}></WrappedComponent>
      </ServiceProvider>
    );
  };
}

function ComponentWrapper({ children }: ComponentProps<any>): ReactElement<any, any> {
  return <>{children}</>;
}

export default withServices(ComponentWrapper, [
  sessionStorage,
  translationService,
  useConfiguration,
  useErrorHandler,
  useMsalProvider,
  useThemeService,
  usePageTitle,
  notificationsService
]);
